/**
 * AI Studio – parent action types.
 * Sub-features will live in subfolders and may use prefixed types (e.g. AI_STUDIO_STREAM_CHAT_*).
 */

// Common / global
export const AI_STUDIO_SET_LOADING = "AI_STUDIO_SET_LOADING";
export const AI_STUDIO_SET_ERROR = "AI_STUDIO_SET_ERROR";
export const AI_STUDIO_RESET = "AI_STUDIO_RESET";
export const AI_STUDIO_SET_STUDIOS = "AI_STUDIO_SET_STUDIOS";
export const AI_STUDIO_SET_CURRENT_STUDIO = "AI_STUDIO_SET_CURRENT_STUDIO";

// Socket-driven (same /ai namespace as CoPilot; stream_chunk, stream_done + shared dcp_*)
export const AI_STUDIO_LOADING_STATUS = "AI_STUDIO_LOADING_STATUS";
export const AI_STUDIO_ACTION_DETECTED = "AI_STUDIO_ACTION_DETECTED";
export const AI_STUDIO_AI_ANSWER = "AI_STUDIO_AI_ANSWER";
export const AI_STUDIO_AI_ERROR = "AI_STUDIO_AI_ERROR";
export const AI_STUDIO_STREAM_CHUNK = "AI_STUDIO_STREAM_CHUNK";
export const AI_STUDIO_STREAM_DONE = "AI_STUDIO_STREAM_DONE";
export const AI_STUDIO_STREAM_RESET = "AI_STUDIO_STREAM_RESET";
export const AI_STUDIO_MEDIA_BLOCK = "AI_STUDIO_MEDIA_BLOCK";
export const AI_STUDIO_MEDIA_STATUS = "AI_STUDIO_MEDIA_STATUS";
export const AI_STUDIO_MEDIA_DONE = "AI_STUDIO_MEDIA_DONE";
